import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from '../controls/advanced-gridview/services/advanced-service';
import { Contact } from '../models/contact';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class ContactsService extends CrudService implements AdvancedService<Contact> {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<Contact>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/contacts`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<Contact>(Contact, x);

                return res;
            })
        );
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/contacts/export`, { headers: headers, responseType: 'blob' }).pipe(
            map((res: any) => {
                const blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                return blob;
            })
        );
    }

    update(contactId: number, contact: Contact): Observable<Contact> {
        // Appel de la Web Api
        return this.http.put<Contact>(this.baseUrl + `/api/organizations/${this.organizationId}/contacts/${contactId}`, contact, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    delete(contactId: number): Observable<boolean> {
        // Appel de la Web Api
        return this.http.delete<Contact>(this.baseUrl + `/api/organizations/${this.organizationId}/contacts/${contactId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return true;
            })
        );
    }

    add(contact: Contact): Observable<Contact> {
        contact.organizationId = this.organizationId;
        // Appel de la Web Api
        return this.http.post<Contact>(this.baseUrl + `/api/organizations/${this.organizationId}/contacts`, contact, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    get(contactId: number): Observable<Contact> {
        // Appel de la Web Api
        return this.http.get<Contact>(this.baseUrl + `/api/organizations/${this.organizationId}/contacts/${contactId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }
}
